import api from "./axios";

export const getReportsDashboard =
() =>
api.get(
  "/reports/dashboard"
);